// extracted by mini-css-extract-plugin
module.exports = {"contactLi":"ContactListItem_contactLi__24SIj","contactLiP":"ContactListItem_contactLiP__CHMIH","contactLiBtn":"ContactListItem_contactLiBtn__37wl7"};